import React, {useState} from "react"
import { FiArchive, FiAtSign, FiBold, FiChevronDown, FiChevronRight, FiCode, FiEdit2, FiFileText, FiHeadphones, FiItalic, FiLink, FiList, FiLogOut, FiMenu, FiMic, FiMoreVertical, FiPaperclip, FiPlus, FiSearch, FiSettings, FiSmile, FiTrash2, FiType, FiUser, FiUserPlus, FiUsers, FiVideo, FiVolume1, FiVolume2, FiVolumeX, FiX, FiZap } from "react-icons/fi"
import { URLRegex } from "../../../../utils/helper"
import clx from "classnames"
import { Send } from "./send"
import { Conversations } from "./conversations"
 
export const Content = ({
    messages,
    handle,
    className
}) => {
    
    return (
        <React.Fragment>
            <div className={clx(className, `content h-screen flex flex-col scrollbar 
      justify-between dark:text-white dark:bg-[#1e2126] bg-gray-50`)}>
                
                <Conversations
                    messages={messages}
                    handle={handle}

                 />
        
            </div>
        </React.Fragment>
    )
}
  
